module.exports = __webpack_public_path__ + "b2444a6e06610d93216682a19fc16e80.svg";